import type { RealtimeTelemetryEvent } from "../shared/realtimeTelemetry";

const TELEMETRY_URL = "/api/realtime/telemetry";

export async function reportRealtimeTelemetry(
  event: RealtimeTelemetryEvent,
  fetchImpl: typeof fetch = fetch,
): Promise<void> {
  const body = JSON.stringify(event);
  if (
    event.event === "ended"
    && typeof navigator !== "undefined"
    && typeof navigator.sendBeacon === "function"
    && typeof location !== "undefined"
    && (location.protocol === "https:" || location.protocol === "http:")
  ) {
    try {
      if (navigator.sendBeacon(
        TELEMETRY_URL,
        new Blob([body], { type: "application/json" }),
      )) return;
    } catch {
      // Fall back to keepalive fetch below.
    }
  }

  try {
    await fetchImpl(TELEMETRY_URL, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    });
  } catch {
    // Observability must never interrupt live translation or teardown.
  }
}
